import { FC } from "react";
import { PlatformSettingForm } from "./PlatformSettingForm";

export const CommissionSettings: FC = () => (
  <PlatformSettingForm
    name="commission_percent"
    title="Комиссия площадки"
    label="Размер комиссии, % *"
    placeholder="10"
    min={0}
    max={100}
    step={0.1}
    hint="Комиссия удерживается из оплаты клиента при назначении исполнителя. Новое значение действует для заказов, которые исполнители возьмут после сохранения; вознаграждение по уже взятым заказам не меняется."
  />
);
